export const AISupporFileType = ['PNG', 'JPG', 'JPEG', 'WEBP'];
